<template>
    <div class="level">
        <el-form label-position="right" label-width="80px" :model="from">
            <el-form-item label="客户名称 :">
                <p>吴彦祖</p>
            </el-form-item>
            <el-form-item v-if="types==1" label="当前等级 :">
                <p>黄金会员</p>
            </el-form-item>
            <el-form-item v-if="types==2" label="当前积分 :">
                <p>100</p>
            </el-form-item>
            
            <el-form-item label="修改为 :">
                <el-input v-if="types==2" placeholder="请输入积分数值" v-model="from.name"></el-input>
                <el-select v-if="types==1" v-model="from.value" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    props:{
        types:{//1为等级，2为积分
            type:String,
            default:'1'
        }
    },
    data() {
        return {
            from:{
                name:"",
                value: ''
            },
            options: [{
            value: '选项1',
            label: '青铜会员'
            }, {
            value: '选项2',
            label: '白金会员'
            }],
        }
    },
    methods: {
        set(){
            return this.from;
        }
    },
}
</script>
<style lang="less" scoped>
    .level{
        padding:30px;
        /deep/ .el-input .el-input__inner{
            width:50%;
             border-radius: 30px;
            background: #F6F6F6;
        }
        /deep/ .el-select{
            width:50%;
        }
        /deep/ .el-select  .el-input .el-input__inner{
                width:100%;
        }
    }
</style>